// Mirrors backend/src/lib/password-policy.js — keep in sync if policy changes
export function validatePassword(password) {
  const errors = []
  if (!password || password.length < 8) errors.push('passwordTooShort')
  if (!/[A-Z]/.test(password)) errors.push('passwordNeedsUppercase')
  if (!/[a-z]/.test(password)) errors.push('passwordNeedsLowercase')
  if (!/[0-9]/.test(password)) errors.push('passwordNeedsNumber')
  if (!/[^A-Za-z0-9]/.test(password)) errors.push('passwordNeedsSpecial')
  return errors
}
